export const SET_ORDER = 'SET_ORDER';
export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const SET_EXISTING_ORDERS = 'SET_EXISTING_ORDERS';
export const GET_EXISTING_ORDER_REQUEST = 'GET_EXISTING_ORDER_REQUEST';
export const GET_EXISTING_GUEST_ORDERS_REQUEST = 'GET_EXISTING_GUEST_ORDERS_REQUEST';
export const GET_ORDER_DELIVERY_DETAILS_REQUEST = 'GET_ORDER_DELIVERY_DETAILS_REQUEST';
export const SET_ORDER_DELIVERY_DETAILS = 'SET_ORDER_DELIVERY_DETAILS';

export const createOrderRequest = (order, onComplete) => ({
  type: CREATE_ORDER_REQUEST,
  order,
  onComplete
});

export const getExistingOrdersRequest = (onComplete) => ({
  type: GET_EXISTING_ORDER_REQUEST,
  onComplete
});

export const getExistingGuestOrdersRequest = (email, phone, onComplete) => ({
  type: GET_EXISTING_GUEST_ORDERS_REQUEST,
  email,
  phone,
  onComplete
});

export const getOrdersDeliveryDetailsRequest = (orderNumber, onComplete) => ({
  type: GET_ORDER_DELIVERY_DETAILS_REQUEST,
  orderNumber,
  onComplete
});
